import React from "react"
import { TypographyProps, Grid } from "@material-ui/core"

import useStyles from "@/components/ClientIdentification/styles"

import ClientNickname from "@/components/ClientIdentification/ClientNickname"
import ClientName from "@/components/ClientIdentification/ClientName"
import LidContactWarning from "@/components/LidContactWarning"

import useContactDisplay from "@/hooks/useContactDisplay"

type ClientIdentificationProps = {
	/**
	 * Name supplied from the channel. Ex: Name on Whatsapp
	 */
	name?: string
	/**
	 * Name set inside Inbox.
	 */
	nickname?: string
	phone?: string
	PrimaryTitleProps?: TypographyProps
	SecondaryTitleProps?: TypographyProps
	isLid?: boolean
}

const ClientIdentification: React.FC<ClientIdentificationProps> = (props) => {
	const {
		name,
		nickname,
		phone,
		PrimaryTitleProps,
		SecondaryTitleProps,
		isLid
	} = props

	const classes = useStyles()
	const { getDisplayName } = useContactDisplay()

	return (
		<Grid container alignItems="center">
			<Grid item>
				<ClientNickname
					{...(PrimaryTitleProps || {})}
					className={PrimaryTitleProps?.className}
				>
					{getDisplayName(nickname, phone) || ""}
				</ClientNickname>
			</Grid>

			<Grid item>
				{name && (
					<ClientName
						name={name}
						phone={phone}
						{...(SecondaryTitleProps || {})}
						className={`${classes.name} ${SecondaryTitleProps?.className}`}
					/>
				)}
			</Grid>

			{
				isLid && (
					<Grid item style={{ marginLeft: 4 }}>
						<LidContactWarning />
					</Grid>
				)
			}
		</Grid>
	)
}

export default ClientIdentification
